import { render, staticRenderFns } from "./LightCard.vue?vue&type=template&id=2768fa15"
import script from "./LightCard.vue?vue&type=script&lang=js"
export * from "./LightCard.vue?vue&type=script&lang=js"
import style0 from "./LightCard.vue?vue&type=style&index=0&id=2768fa15&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports